import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=e2d96eb4&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d96eb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2d96eb4')) {
      api.createRecord('e2d96eb4', component.options)
    } else {
      api.reload('e2d96eb4', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=e2d96eb4&scoped=true&", function () {
      api.rerender('e2d96eb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JEOI2ILSftNn/JS/comp/Accordion.vue"
export default component.exports